module.exports = __webpack_public_path__ + "img/87b1cd37c28fa98ebbfa0ec8353b1322.jpg";